export function errorsMapperConstructor<T>(
  errorMapper: (response: any) => T
) {
  return function (response: any) {
    return errorMapper(response);
  };
};
